/**
 * User Management Utility Functions
 * Exact copy of admin-web logic for consistency
 */

import { IApiRole, IApiUser } from '@/types/admin/userManagement';

/**
 * Construct user organizations from roles (matching admin-web logic exactly)
 */
export const constructUserOrgs = (user: IApiUser) => {
  const orgIds: number[] = [];
  const userOrgs = user.roles?.flatMap((role: IApiRole) => {
    if (!role.organization?.id || orgIds.includes(role.organization?.id)) {
      return null;
    }
    orgIds.push(role.organization?.id);
    return role.organization?.name;
  });
  if (!userOrgs) return undefined;
  return userOrgs.filter((org: string | null) => {
    return org;
  });
};

/**
 * Construct user properties from roles (matching admin-web logic exactly)
 */
export const constructUserProperties = (user: IApiUser) => {
  const propertyIds: number[] = [];
  const userProperties = user.roles?.flatMap((role: IApiRole) => {
    if (!role.property?.id || propertyIds.includes(role.property?.id)) {
      return null;
    }
    propertyIds.push(role.property?.id);
    return role.property?.marketingName;
  });
  if (!userProperties) return undefined;
  return userProperties.filter((prop: string | null) => {
    return prop;
  });
};

/**
 * Capitalize first letter (matching admin-web utility)
 */
export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};
